import { nuvemEnvioLabelsAppLinkPrefixes } from '../pages/constants';

export const isNuvemEnvioLink = (link: string) =>
  nuvemEnvioLabelsAppLinkPrefixes.some((substring) => link.includes(substring));
